import { PLAYER_O, PLAYER_X, SCORES, GAME_STATES } from "./constants";

export const switchPlayer = player => {
  return player === PLAYER_X ? PLAYER_O : PLAYER_X;
};

export const getPlayerStatus = (player, winner, gameState) => {
  if (winner !== null && gameState === GAME_STATES.over) {
    return 'GAME OVER';
  } else {
    return player === PLAYER_X ? 'Player X\'s turn' : 'Player O\'s turn';
  }
}

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const minimax = (board, player) => {
  const mult = SCORES[String(player)];
  let thisScore;
  let maxScore = -1;
  let bestMove = null;

  if (board.getWinner() !== null) {
    return [SCORES[board.getWinner()], 0];
  } else {
    for (let empty of board.getEmptySquares()) {
      let copy = board.clone();
      copy.makeMove(empty, player);
      thisScore = mult * minimax(copy, switchPlayer(player))[0];

      if (thisScore >= maxScore) {
        maxScore = thisScore;
        bestMove = empty;
      }
    }

    return [mult * maxScore, bestMove];
  }
};